import React from 'react';
import PropTypes from 'prop-types';
import renderHTML from 'react-render-html';
import Dropdown from '../Dropdowns/Dropdown';
import Icon from '../Icons/Icon';

const TooltipWithDropdown = ({ tooltipText, ...rest }) => {
  const helpIcon = (
    <Icon name="help-outline" size="s" fill="grey" />
  );

  return (
    <div className="tooltip-with-dropdown">
      <Dropdown size="s" label={helpIcon} dark noArrow {...rest}>
        <div className="tooltip-with-dropdown__content dropdown-item">
          <p className="fw-medium">{renderHTML(tooltipText)}</p>
        </div>
      </Dropdown>
    </div>
  );
};

TooltipWithDropdown.propTypes = {
  tooltipText: PropTypes.string,
};

export default TooltipWithDropdown;



// WEBPACK FOOTER //
// ./library/app/components/Global/Tooltips/TooltipWithDropdown.js